module.exports = __webpack_public_path__ + "img/4_goje.559c5669.jpg";